import React from 'react';
import { Badge } from 'react-bootstrap';

// Xác định kiểu dữ liệu hợp lệ cho trạng thái
type StatusType = 'Buổi đầu nhập học' | 'Học sinh mới' ;

const statusColors: Record<StatusType, string> = {
//   present: 'success',  // Xanh lá
//   absent: 'danger',    // Đỏ
  'Buổi đầu nhập học': 'warning',     // Vàng
  'Học sinh mới': 'info',     // Xanh dương nhạt
};

interface StatusBarProps {
  status: StatusType;
}

const StatusBar: React.FC<StatusBarProps> = ({ status }) => {
  return (
    <Badge
      bg={statusColors[status]}
      style={{ borderRadius: '8px', padding: '5px 10px', whiteSpace: 'nowrap', color:'white' }}
    >
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </Badge>
  );
};

export default StatusBar;
